import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'hongkongprotests',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './fijiscyclonesarai.component.html',
  styleUrl: './fijiscyclonesarai.component.scss',
})
export class FijiscyclonesaraiComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = `Fiji's Cyclone Sarai`;

  ngOnInit() {
    this.titleService.setTitle(`Fiji's Cyclone Sarai`);
    this.metaService.updateTag({
      property: 'og:title',
      content: `Fiji's Cyclone Sarai`,
    });
    this.pageContent = this.sanitizer.bypassSecurityTrustHtml(``);
    this.pageTitleImg = 'assets/images/w2c/page-header/how-to-claim.jpg';
  }
}
